import './modules/my-account';
import './message-handlers/piano-id-callback-handlers';
import './modules/login';
import './modules/registration';
import './modules/lost-password';
import PianoCustomEvents from './piano-custom-events';

const pianoInit = () => {
	window.pianoCustomEvents = PianoCustomEvents;
	window.addEventListener( 'message', window.pianoCustomEvents.messageHandler );

	const signInButtons = document.querySelectorAll('.js-sign-in-button');
	signInButtons.forEach(button => {
		button.addEventListener('click', (e) => {
			loginShowHandler();
		})
	});

	const logoutButtons = document.querySelectorAll('.js-logout');
	logoutButtons.forEach(button => {
		button.addEventListener('click', (e) => {
			tp.pianoId.logout();
		})
	});
};

if ( 'loading' !== document.readyState ) {
	pianoInit();
} else {
	document.addEventListener( 'DOMContentLoaded', pianoInit );
}
